<div class="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900">
  <div class="text-center p-8 bg-white dark:bg-gray-800 rounded-lg shadow-lg max-w-md">
    <div class="mb-6">
      <i class="pi pi-lock text-6xl text-red-500"></i>
    </div>

    <h1 class="text-3xl font-bold text-gray-800 dark:text-gray-100 mb-4">
      {{ 'common.unauthorized.title' | translate }}
    </h1>

    <p class="text-gray-600 dark:text-gray-300 mb-8">
      {{ 'common.unauthorized.message' | translate }}
    </p>

    <div class="flex gap-4 justify-center">
      <button
        pButton
        type="button"
        [label]="'common.unauthorized.goBack' | translate"
        icon="pi pi-arrow-left"
        class="p-button-outlined"
        (click)="goBack()">
      </button>

      <button
        pButton
        type="button"
        [label]="'common.unauthorized.logout' | translate"
        icon="pi pi-sign-out"
        severity="danger"
        (click)="logout()">
      </button>
    </div>
  </div>
</div>
